import "../stylesheets/App.css";
import "../stylesheets/Profile.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./subcomponents/Header.js";
import Loader from "./subcomponents/Loader.js";
import PopupInfo from "./subcomponents/PopupInfo.js";

function Profile() {
  const navigate = useNavigate();

  const [loadingCountries, setLoadingCountries] = useState(true);
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [cedula, setCedula] = useState("");
  const [age, setAge] = useState("");
  const [clientNumber, setClientNumber] = useState("");
  const [idCountry, setIdCountry] = useState(1);

  const [countries, setCountries] = useState([]);
  const [activePopup, setActivePopup] = useState(false);

  const [nameError, setNameError] = useState(false);
  const [cedulaError, setCedulaError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [clientNumberError, setClientNumberError] = useState(false);
  const [ageError, setAgeError] = useState(false);

  const apiCall = (url, onSuccess) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => onSuccess(data))
      .catch((error) => console.log(error));
  };

  const updateCountries = (data) => {
    setCountries(data.data || []);
    setLoadingCountries(false);
  };

  const infoUser = (data) => {
    if (!data) return;
    setName(data.name || "");
    setCedula(data.cedula || "");
    setEmail(data.email || "");
    setAge(data.age || "");
    setPhone(data.phone || "");
    setClientNumber(data.client_number || "");
    setIdCountry(data.idCountry || 1);
  };

  // ✅ Redirects + init data (en effect, no en render)
  useEffect(() => {
    const raw = localStorage.getItem("user-info");
    if (!raw) {
      navigate("/login");
      return;
    }

    const parsed = JSON.parse(raw);
    if (parsed?.is_admin) {
      navigate("/admin");
      return;
    }

    apiCall(
      process.env.REACT_APP_API_BASE_URL + "/countries/list",
      updateCountries
    );
    infoUser(parsed);

    // ✅ No rompe si el elemento no existe
    const el = document.getElementById("search-container");
    if (el) el.style.display = "none";
  }, [navigate]);

  const profile = async () => {
    setLoadingUpdate(true);
    setErrorMsg("");
    setActivePopup(false);

    // reset errores
    setNameError(false);
    setCedulaError(false);
    setPhoneError(false);
    setClientNumberError(false);
    setAgeError(false);

    // validaciones front
    const isAllOk = !!(name && cedula && email && age && phone && clientNumber);

    if (!isAllOk) {
      setLoadingUpdate(false);
      setNameError(!name);
      setCedulaError(!cedula);
      setPhoneError(!phone);
      setClientNumberError(!clientNumber);
      setAgeError(!age);
      setErrorMsg("Debe completar todos los campos");
      return;
    }

    try {
      const idCategory = 1; // mismo comportamiento que antes
      const item = { name, cedula, email, age, phone, client_number: clientNumber, idCountry, idCategory };

      let result = await fetch(
        process.env.REACT_APP_API_BASE_URL + "/users/update",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );
      result = await result.json();

      if (result.status === 200) {
        let resultUser = await fetch(
          process.env.REACT_APP_API_BASE_URL + "/users/getByEmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ email }),
          }
        );
        resultUser = await resultUser.json();

        if (resultUser.status === 200) {
          localStorage.setItem("user-info", JSON.stringify(resultUser.data));
          setActivePopup(true);
        }
      } else {
        setErrorMsg(result?.data?.errors?.[0]?.msg || "Error al actualizar");
      }
    } catch (e) {
      console.log(e);
      setErrorMsg("Error de red, intentá de nuevo");
    } finally {
      setLoadingUpdate(false);
    }
  };

  return (
    <>
      <Header />

      <div className="profile-container section-70">
        <h1 className="profile-title">Actualizar datos</h1>

        <label>Nombre completo</label>
        <div className="inp">
          <input
            className="inp-reg"
            type="text"
            placeholder="Nombre completo"
            id="name"
            name="name"
            onChange={(e) => {
              const result = e.target.value.replace(
                /[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ ]/g,
                ""
              );
              setName(result);
            }}
            value={name}
          />
          {nameError && (
            <>
              <div className="error-message">
                Por favor agrega el nombre completo
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/register/iconError.svg"}
                className="img-error"
                alt=""
              />
            </>
          )}
        </div>

        <label>Número de identificación</label>
        <div className="inp">
          <input
            className="inp-reg"
            type="number"
            placeholder="Cédula"
            id="cedula"
            name="cedula"
            onChange={(e) => setCedula(e.target.value)}
            value={cedula}
          />
          {cedulaError && (
            <>
              <div className="error-message">
                Por favor agrega número de identificación
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/register/iconError.svg"}
                className="img-error"
                alt=""
              />
            </>
          )}
        </div>

        <label>Correo electrónico</label>
        <div className="inp disabled-inp">
          <input
            className="inp-reg"
            type="text"
            placeholder="Correo electrónico"
            id="email"
            name="email"
            disabled
            value={email}
          />
        </div>

        <label>Teléfono</label>
        <div className="inp">
          <input
            className="inp-reg"
            type="text"
            placeholder="Número de teléfono"
            id="phone"
            name="phone"
            onChange={(e) => setPhone(e.target.value)}
            value={phone}
          />
          {phoneError && (
            <>
              <div className="error-message">
                Por favor agrega número de teléfono
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/register/iconError.svg"}
                className="img-error"
                alt=""
              />
            </>
          )}
        </div>

        <label>Número de cliente</label>
        <div className="inp">
          <input
            className="inp-reg"
            type="text"
            placeholder="Número de cliente"
            id="clientNumber"
            name="clientNumber"
            onChange={(e) => {
              const result = e.target.value.replace(/\D/g, "");
              setClientNumber(result);
            }}
            value={clientNumber}
          />
          {clientNumberError && (
            <>
              <div className="error-message">Por favor agrega el número de cliente</div>
              <img
                src={process.env.PUBLIC_URL + "/images/register/iconError.svg"}
                className="img-error"
                alt=""
              />
            </>
          )}
        </div>

        <label>Edad</label>
        <div className="inp">
          <input
            className="inp-reg"
            type="number"
            placeholder="Edad"
            id="age"
            name="age"
            onChange={(e) => setAge(e.target.value)}
            value={age}
          />
          {ageError && (
            <>
              <div className="error-message">Por favor agregar edad</div>
              <img
                src={process.env.PUBLIC_URL + "/images/register/iconError.svg"}
                className="img-error"
                alt=""
              />
            </>
          )}
        </div>

        {/* (Opcional) select país si lo usan en UI; se deja countries cargado igual */}
        {/* 
        <select value={idCountry} onChange={(e) => setIdCountry(Number(e.target.value))}>
          {countries.map((c) => (
            <option key={c.idCountry} value={c.idCountry}>{c.name}</option>
          ))}
        </select>
        */}

        <span className="error-msg">{errorMsg}</span>

        <button
          type="submit"
          className="btn red-btn mb-1 mt-2"
          onClick={profile}
        >
          Actualizar datos
        </button>

        <button className="btn blue-btn" onClick={() => navigate("/")}>
          Cancelar
        </button>

        <br />
        <br />

        <span className="profile-changepass">
          Deseas cambiar la contraseña?{" "}
          <a className="profile-a" onClick={() => navigate("/change-password")}>
            Actualizar
          </a>
        </span>
      </div>

      {activePopup ? (
        <PopupInfo description="Datos modificados exitosamente" setOpenPopup={setActivePopup} />
      ) : null}

      {loadingCountries || loadingUpdate ? <Loader /> : null}
    </>
  );
}

export default Profile;
